import { render, staticRenderFns } from "./AddCreditNote.vue?vue&type=template&id=387266b8&scoped=true&"
import script from "./AddCreditNote.vue?vue&type=script&lang=js&"
export * from "./AddCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./AddCreditNote.vue?vue&type=style&index=0&id=387266b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387266b8",
  null
  
)

export default component.exports